import script from "./PasswordForgotSuccessView.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordForgotSuccessView.vue?vue&type=script&setup=true&lang=js"

import "./PasswordForgotSuccessView.vue?vue&type=style&index=0&id=32aa4269&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32aa4269"]])

export default __exports__